"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArrayLike = void 0;

var isArrayLike = function isArrayLike(x) {
  return x && typeof x.length === 'number';
};

exports.isArrayLike = isArrayLike;